// eslint-disable-next-line
export const BCC_DEFAULT_EMAIL = 'coordinator@preceptorlink.com';
